import axios from 'axios';

const instance = axios.create({
	baseURL: process.env.VUE_APP_API_BASE_URL,
	timeout: 5000,
	withCredentials: true,
	headers: {
		'Content-Type': 'application/json',
		'Accept': 'application/json',
		'X-Requested-With': 'XMLHttpRequest',
	}
});

instance.interceptors.request.use(
	config => {
		const userStateString = localStorage.getItem('user_state');
		const userState = userStateString ? JSON.parse(userStateString) : null;
		const jwtToken = userState ? userState.jwtToken : null;

		if (jwtToken) {
			config.headers.Authorization = `Bearer ${jwtToken}`;
		}

		return config;
	},
	error => {
		return Promise.reject(error);
	}
);

export default instance;
